import { space } from "@ecco/ui/tokens";

export const sizeBtnUnavailableStyles = {
    bg: "grayUnavailableBg",
    color: "grayUnavailableText",
    cursor: "pointer",
    _hover: {
        bg: "gray.200",
        color: "white",
    },
    _focus: {
        bg: "gray.200",
        color: "white",
    },
    _active: {
        bg: "gray.200",
        color: "white",
    },
};
export const styles = {
    container: {
        mb: [6, 6, 6, 4],
        px: [3, 3, 3, 0],
        bg: "white",
        h: "fit-content",
        display: "flex",
        flexDirection: "column",
    },
    headerContainer: {
        mb: [0, 8],
        position: "relative",
    },
    variantTitleWishlist: {
        alignItems: "flex-start",
        justifyContent: "space-between",
        mt: 4,
    },
    variantImage: {
        width: 84,
        height: 55,
        borderColor: "gray.100",
        borderWidth: space["0.2"],
        borderStyle: "solid",
    },
    variantImageSelected: {
        borderColor: "black",
    },

    submitContainer: {
        w: "100%",
    },
    submitButton: {
        w: "100%",
        bg: "black",
        color: "white",
    },
    submitButtonSelectSize: {
        w: "100%",
        bg: "black",
        color: "white",
    },
    sizeButtonAvailable: {
        bg: "gray.100",
        color: "black",
        _hover: {
            bg: "gray.200",
        },
    },
    sizeButtonAvailableSelected: {
        bg: "black",
        color: "white",
        _hover: {
            bg: "gray.800",
        },
    },
    sizeSystemSelected: {
        bg: "black",
        color: "white",
    },
    sizeSystemUnSelected: {
        bg: "gray.100",
        color: "black",
        _hover: {
            bg: "gray.50",
            color: "black",
        },
    },
};
